import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4515114c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=4515114c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4515114c",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CIcon: require('@chakra-ui/vue').CIcon, CTooltip: require('@chakra-ui/vue').CTooltip, CFlex: require('@chakra-ui/vue').CFlex, CDivider: require('@chakra-ui/vue').CDivider, CBox: require('@chakra-ui/vue').CBox})
